import React from 'react'
import Button from '../../Components/Button'
import Navbar from '../../Components/Navbar'
import GameOver from './GameOver'
import Win from './Win'
import { Link } from 'react-router-dom'
export default class SchulteHard extends React.Component {
    constructor() {
        super()
        this.state = {
            timeLeft: 59,
            timerInterval: null,
            totalNum: 36,
            gameOver: false,
            newGameStart: false,
            previousNumber: 0,
            nums: [],
            colorArray: []
        }
        this.SuffleTheBoard = this.SuffleTheBoard.bind(this)
        this.makeEmpty = this.makeEmpty.bind(this)
        this.NewGame = this.NewGame.bind(this)
        this.afterGameOver = this.afterGameOver.bind(this)
        this.startTimer = this.startTimer.bind(this)
    }
    startTimer() {
        this.setState({
            timerInterval: setInterval(() => {
                this.setState(prevState => { return { timeLeft: prevState.timeLeft - 1 } });
                if (this.timeLeft === 0) {
                    this.setState({ gameOver: true })
                }
            }, 1000)
        })
    }
    //SuffleTheBoard is an onClick function which fills all the grid items with random number from 1 to 25 without repeatition
    SuffleTheBoard() {
        this.setState(() => {
            var nums = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36], //all numbers to be randomized
                colors = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
                ranNums = [],
                i = nums.length,
                j = 0;

            while (i--) {
                j = Math.floor(Math.random() * (i + 1));
                ranNums.push(nums[j]);
                nums.splice(j, 1);
            }
            i = colors.length;
            j = 0;
            let ranColors = [];
            while (i--) {
                j = Math.floor(Math.random() * (i + 1));
                ranColors.push(colors[j]);
                colors.splice(j, 1);
            }
            let generatedRandom = {
                colorArray: [],
                nums: []
            }
            for (let i = 0; i < ranNums.length; i++) {
                generatedRandom.nums[i] = ranNums[i]
            }
            let colorProp = "color"
            for (let i = 0; i < ranColors.length; i++) {
                generatedRandom.colorArray.push(colorProp + ranColors[i])
            }
            generatedRandom.totalNum = 36
            return generatedRandom;
        })
    }

    //this is an example of parameterized function for onClick
    //this funtion first checks wheather the particular num is null or not 
    // i.e.wheaher the particular num is already clicked or not if not we make total count-1 and update it to null
    makeEmpty(index) {
        if (this.state.nums[index] === null || this.state.nums[index] !== this.state.previousNumber + 1) {
            this.setState({ gameOver: true })
        }
        else {
            this.setState({ previousNumber: this.state.nums[index] })
            this.SuffleTheBoard()
            this.setState(prevState => {
                return {
                    totalNum: prevState.totalNum - 1,
                }
            })
        }
    }
    NewGame() {
        this.setState({ newGameStart: true })
        this.setState({ previousNumber: 0 })
        this.SuffleTheBoard()
        this.setState({ timeLeft: 59 })
    }
    afterGameOver() {
        this.setState({ gameOver: false })
        this.startTimer()
        this.NewGame()
    }
    componentDidMount() {
        this.NewGame()
        this.startTimer()
        console.log("dipti")
    }
    render() {
        if (this.state.gameOver !== true && this.state.totalNum === 0 && this.state.timeLeft > 0) {
            clearInterval(this.state.timerInterval)
            return (
                <Win click={this.afterGameOver} score={this.state.previousNumber} ></Win>
            )
        }
        if (this.state.gameOver === true || this.state.timeLeft <= 0) {
            clearInterval(this.state.timerInterval)
            return (
                <GameOver click={this.afterGameOver} score={this.state.previousNumber} />
            )
        }
        else {
            let timerClass = "timer-green"
            if (this.state.timeLeft <= 15 && this.state.timeLeft !== null) {
                timerClass = "timer-yellow"
            }
            if (this.state.timeLeft <= 7 && this.state.timeLeft !== null) {
                timerClass = "timer-red"
            }
            return (
                <>
                    <header>
                        <Navbar />
                    </header>
                    <main className="main">
                        <div className="timer-base">
                            <div className={timerClass}>Time Left: 00:{this.state.timeLeft}</div>
                        </div>
                        <div className="grid">
                            {
                                this.state.nums.map((number, index) => {
                                    //let colorIndex=index%18
                                    return <Button click={() => this.makeEmpty(index)} btn={this.state.colorArray[index % 18]} number={number}></Button>
                                })
                            }
                        </div>
                        <div className="footer">
                            <Button click={this.NewGame} btn="other-button" number="Restart"></Button>
                            <Link to="/schulteHome"><Button btn="other-button" number="Back"></Button></Link>
                        </div>
                    </main>
                </>
            )
        }
    }
}
